import { connect } from 'react-redux'

import {
  createTimer,
  editMenu,
  favorRecipe,
  openModal,
  showError,
} from '../../store/actions'

import UserGeneratedRecipePage from './UserGeneratedRecipePage'

const mapStateToProps = ({ profile, auth, menu, config, timer }) => ({
  profile,
  auth,
  menu,
  config,
  timer,
})
const mapDispatchToProps = {
  createTimer,
  editMenu,
  favorRecipe,
  openModal,
  showError,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserGeneratedRecipePage)
